<div mat-dialog-content>
  <app-images-carrousel [height]="'90vh'" [width]="'90vw'" [images]="images" [initCurrentIndex]="currentIndex"
                        (getCurrentIndex)="getCurrentIndex($event)"></app-images-carrousel>
</div>
